import type { RouteWithTitle } from '@pbk-web/types';
import { Roles } from '@pbk-web/types';
import { lazy } from 'react';

const instancesV2Routes: RouteWithTitle[] = [
  {
    // Root folders from the framework V2 API, linked from the left nav
    id: 'instances-v2-folder',
    path: '/clients/:clientId/folders/:folderId',
    translationKey: 'page.instances-v2-folder',
    component: lazy(() => import('../pages/FolderPage')),
    permissions: [Roles.Employee],
    postHogFlag: 'playbook-forms-v2',
  },
];

export default instancesV2Routes;
